import { RouteFactory } from "@app/routePaths";
import { AdvertisementTypeEnum } from "@app/types/enums";
import uobLogo from "@assets/logo-uob-blue.png";
import aseanBusinessLogo from "@assets/verticals/asean-logo-black.svg";
import { AdTargetingType } from "@components/Advertisement/AdUnit";
import Advertisement from "@components/Advertisement/Advertisement";
import SectionMasthead from "@components/SectionMasthead/SectionMasthead";
import { GoogleAdsSlotFactory } from "@util/helpers";

export default function AseanBanner({
  slotTargettings = [],
}: {
  slotTargettings?: AdTargetingType[];
}): React.ReactElement {
  return (
    <>
      <div className="flex w-full flex-wrap items-center justify-center gap-2 pb-2 md:justify-between">
        <SectionMasthead
          link={RouteFactory.aseanBusiness}
          masthead={{
            alt: "Asean Business logo",
            src: aseanBusinessLogo,
            width: 240,
            height: 57,
          }}
        />
        <div className="block h-[1px] w-full bg-gray-850 md:hidden "></div>
        <div className="flex items-center justify-end gap-x-4">
          <span className="font-poppins text-4xs font-light">SPONSORED BY</span>
          <img src={uobLogo} alt="UOB logo" className="w-[5rem]" width="90" />
        </div>
      </div>
      <div className="mb-5 hidden h-[1px] w-full bg-gray-850 md:block "></div>
      <Advertisement
        rootClassName="pb-6"
        adUnitProps={{
          slot: GoogleAdsSlotFactory.lb1(
            RouteFactory.aseanBusiness.replace("/", "")
          ),
          type: AdvertisementTypeEnum.LB1,
          slotTargettings: slotTargettings,
        }}
      />

      <Advertisement
        adUnitProps={{
          type: AdvertisementTypeEnum.CATFISH,
          slot: GoogleAdsSlotFactory.lb1(
            RouteFactory.aseanBusiness.replace("/", "")
          ),
          slotTargettings: slotTargettings,
        }}
      />

      <Advertisement
        adUnitProps={{
          type: AdvertisementTypeEnum.ABM,
          slot: GoogleAdsSlotFactory.abm(),
        }}
      />
    </>
  );
}
